import { useState } from 'react';

import type { Portfolios } from '@/hooks/portfolio/usePortfolio';

import ListItem from '../ListItem';

import { generateName, generateDetails } from '../../utils';

import { useAddHoldingsToManualPortfolio } from '@/hooks/portfolio/useAddHoldingsToManualPortfolio';

interface Props {
  portfolio: Portfolios[number];
  companyId: string;
  uniqueSymbol: string;
}

export const ManualPortfolioListItem = ({
  portfolio,
  uniqueSymbol,
  companyId,
}: Props) => {
  const [isIncluded, setIsIncluded] = useState(() =>
    portfolio.holdings.some(
      (n) => n.companyId.toUpperCase() === companyId.toUpperCase()
    )
  );

  const { mutate, status } = useAddHoldingsToManualPortfolio({
    onSuccess: () => setIsIncluded(true),
  });

  return (
    <ListItem
      key={portfolio.id}
      name={portfolio.id}
      title={generateName(portfolio.name, portfolio.currencyISO)}
      details={generateDetails(null, portfolio.holdings.length)}
      disabled={isIncluded}
      isUpdating={status === 'pending'}
      checked={isIncluded}
      handleClick={() => {
        const [exchangeCode, symbol] = uniqueSymbol.split(':');
        mutate({
          id: portfolio.id,
          holdings: [{ exchangeCode, symbol }],
        });
      }}
    />
  );
};
